import { axiosSecuredInstance } from "configurations/axiosConfig";
import { createHook, createStore, StoreActionApi } from "react-sweet-state";

export type DragDropColumnType = {
  field: string;
  name?: string;
  position: number;
};

type State = {
  error: string | null;
};

const initialState: State = {
  error: null,
};

type Actions = typeof actions;
type StoreApi = StoreActionApi<State>;

const actions = {
  setColumnsDefinition:
    (columnsDefinition: DragDropColumnType[], columnsUrl: string) =>
    async ({ setState }: StoreApi) => {
      try {
        await axiosSecuredInstance.post(
          `UISettings/grids/columnSettings/${columnsUrl}`,
          columnsDefinition
        );
        setState({ error: null });
      } catch (error: any) {
        console.error(error);
        setState({ error: error?.message ?? "Failed to save column settings" });
      }
    },
};

const Store = createStore<State, Actions>({
  initialState,
  actions,
  name: "columnSettings",
});

const hook = createHook(Store);
export const useColumnSettings = () => hook();
